module.exports = __webpack_public_path__ + "img/kh.952f3476.svg";